import React from 'react';
import { Box } from '@mui/material';
import Typography from '@ui/Typography';
import Tag from '@ui/Tag';
import { ModelOptionProps } from './types';
import ModelOption from './ModelOption';

const LegacyOption = ({
  active,
  disabled,
}: Pick<ModelOptionProps, 'disabled' | 'active'>) => {
  return (
    <ModelOption
      variant={'primary'}
      disabled={disabled}
      active={active}
      title={
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <Typography id="models-label" variant="pMd" component="h3" bold>
            Legacy Studio - Standard
          </Typography>
          <Tag variant="papaya">Retiring</Tag>
        </Box>
      }
      description={
        'Our original, simplified editor experience built for the Standard voice model.'
      }
      icon={undefined}
    />
  );
};

export default LegacyOption;
